import React from 'react';

const Progress = (props) => {
    return (
    <div className="centered-content progress" {...props}>
       Loading..
    </div>
    );
};

export default Progress;


// WEBPACK FOOTER //
// ./src/components/common/progress.js